var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar"},[(!!_vm.imageUrl)?_c('div',[_c('div',{staticClass:"avatar-image",style:(`background-image: URL(${_vm.imageSrc})`)})]):_c('div',[_c('i',{staticClass:"fa text-primary",class:_vm.icon,staticStyle:{"font-size":"15rem"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }